/**
 * Fonctions utilitaires sur les Objets JS
 *
 * @author lwroblewski
 */
export class WizObjectUtils {

  /** Check d'égalité par valeur entre deux objets complexes */
  public static deepEquals(pObjectOne: any, pObjectTwo: any): boolean {
    if ((pObjectOne && !pObjectTwo) || (!pObjectOne && pObjectTwo)) {
      return false;
    }
    const keys1 = Object.keys(pObjectOne);
    const keys2 = Object.keys(pObjectTwo);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = pObjectOne[key];
      const val2 = pObjectTwo[key];
      const areObjects =
        WizObjectUtils.isObject(val1) && WizObjectUtils.isObject(val2);
      if (
        (areObjects && !WizObjectUtils.deepEquals(val1, val2)) ||
        (!areObjects && val1 !== val2)
      ) {
        return false;
      }
    }
    return true;
  }

  /** Teste si le paramètre d'entrée est un object JS */
  public static isObject(pObject: any): boolean {
    return pObject != null && typeof pObject === 'object';
  }
}
